import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import ScriptDialog from 'app/fuse-layouts/shared-components/ScriptDialog';
import OwnerSelectionCard from 'app/shared-components/OwnerSelectionCard';
import { GlobalProvisionScriptsPreview, ClusterApplicationsSection } from '../components';
import {
    Button, DialogContent, DialogTitle, Divider, Fab, Icon, IconButton, InputBase, FormControl, FormControlLabel, MenuItem, Paper,
    Popover, Radio, RadioGroup, TextField, Typography, Table, TableBody, TableCell, TableHead, TableRow, InputAdornment, Menu, Checkbox,
    Box, Tooltip, Card, CardHeader, CardContent
} from '@material-ui/core';
import { useInstanceAvailability } from '../hooks/useInstanceAvailability';
import { ZoneAvailabilityIndicator } from '../components/ZoneAvailabilityComponents';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import clsx from 'clsx';
import Formsy from 'formsy-react';
import { CheckboxFormsy, FuseAnimate, SelectFormsy, TextFieldFormsy } from '@fuse';
import { useForm } from '@fuse/hooks';
import _ from '@lodash';
import { useDispatch, useSelector } from 'react-redux';
import * as ActionsDialog from 'app/store/actions';
import * as Actions from '../store/actions';
import * as MarketActions from 'app/main/marketplace/store/actions';
import * as StackActions from 'app/main/stacks/store/actions/stacks.actions.js';
import { ipValid, setinstancesVol, validationInputUlt, validationMessUlt } from '../../util/InputValidate';
import { API_BASE_URL } from '@config';
import axios from 'axios';
import useStyles from 'app/cluster-styles/useStyles';
import { getClusterSettings } from 'app/main/settings/store/actions';
import { CLUSTER_STATES, DisabledFormWrapper } from 'app/main/util/clusterUtils';
import { IMAGE_MODE, RESOURCE_MANAGER } from '../../util/enums';
export const TEMPORARY_SUPPORTED_MIG_CAPABLE_DEVICE = 'BM.GPU4.8';
export const TEMPORARY_MIG_MODES = ['all-disabled', 'all-1g.5gb', 'all-2g.10gb', 'all-3g.20gb'];


const OracleCluster = props => {
    // initialize
    const dispatch = useDispatch();
    const classes = useStyles(props);
    const formRef = useRef(null);
    const pkgRef = useRef(null);

    // connect to Redux
    const clusterSettings = useSelector(({ settings }) => settings.settings.clusterSettings);
    const cluster = useSelector(({ clusters }) => clusters.cluster.cluster);
    const clustersArr = useSelector(({ clusters }) => clusters.cluster.list);
    const error = useSelector(({ clusters }) => clusters.cluster.error);
    const providers = useSelector(({ providers }) => providers.providers.list);
    const loading = useSelector(({ fuse }) => fuse.settings.loading);
    const credentials = useSelector(({ credentials }) => credentials.credential.list);
    const supportedOSs = useSelector(({ clusters }) => clusters.cluster.os_types);
    const selectedMarketStack = useSelector(({ marketStack }) => marketStack.marketStack.stack);
    const marketplaceData = useSelector(({ marketStack }) => marketStack.marketStack.list);
    const stacks = useSelector(({ stacks }) => stacks.stack.list);
    const currentUser = useSelector(({ auth }) => auth.user);

    // local state
    const [isFormValid, setIsFormValid] = useState(false);
    const [zones, setZones] = useState([]);
    const [regions, setRegions] = useState([]);
    const [nodeInstanceSizes, setNodeInstanceSizes] = useState(null);
    const [serverInstanceSizes, setServerInstanceSizes] = useState([]);
    const [filteredCredentials, setFilteredCredentials] = useState([]);
    const [deletedPkgs, setDeletedPkgs] = useState([]);
    const [cost, setCost] = useState(0);
    const [providerVolsize, setProviderVolsize] = useState({ min: 10, max: 1000 });
    const [prefixError, setPrefixError] = useState("");
    const [nodePrefixErrors, setNodePrefixErrors] = useState([])
    const [clusterNames, setClusterNames] = useState(null)
    const [selectedOwner, setSelectedOwner] = useState('');
    const [imageMode, setImageMode] = useState(IMAGE_MODE.MULTI_IMAGE);

    //this is for the prefix form
    const groupNodePrefixRefs = useRef([]);
    const textFieldRef = useRef(null);
    const [activeMenuIndex, setActiveMenuIndex] = useState(null);
    const [groupNodeInputValues, setGroupNodeInputValues] = useState({});
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [advanced, setAdvanced] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    //quotas
    const [usedIntances, setUsedIntances] = useState(0);
    const [usedNetwork, setUsedNetwork] = useState(0);
    const [usedCpus, setUsedCpus] = useState(0);
    const [limitIntances, setLimitIntances] = useState(9999999);
    const [limitNetwork, setLimitNetwork] = useState(9999999);
    const [limitCpus, setLimitCpus] = useState(9999999);

    //custom hook
    const { form, handleChange, setForm } = useForm(props.oldForm || null); // <-- This must stay here

    //market information:
    const market_id_value = selectedMarketStack?.id
    const marketId = form?.info?.market_id ?? market_id_value
    const isMarketStack = Boolean(selectedMarketStack)
    const currentMarketStack = marketplaceData?.[marketId]
    const marketName = currentMarketStack?.name
    const marketVersion = currentMarketStack?.version
    const title = currentMarketStack ? (marketName + ' ' + marketVersion) : form?.name || 'New Cluster'
    const imageSrc = currentMarketStack?.logo
        ? `assets/images/logos/${currentMarketStack?.logo}`
        : `assets/images/providers/oracle.png`;

    const [isVncTokenAuthentication, setIsVncTokenAuthentication] = useState(false);
    const [isVncRemoteClient, setIsVncRemoteClient] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const [isScriptOpen, setScriptOpen] = useState(false);
    const [excludedGlobalScripts, setExcludedGlobalScripts] = useState([]);
    // Cluster applications state (Feature: cluster-apps)
    const [clusterApplications, setClusterApplications] = useState([]);

    // Compute node instance types for availability check
    var computeNodeInstanceTypes = useMemo(function() {
        if (!form || !form.data || !form.data.node || !form.data.node.group) return [];
        return form.data.node.group.map(function(g) { return g.instance_id; }).filter(Boolean);
    }, [form && form.data && form.data.node && form.data.node.group]);

    // Instance availability hook for Oracle
    var oracleCredentialId = form && form.credential_id;
    var oracleRegion = form && form.data && form.data.network && form.data.network.region_id;
    var oracleZone = form && form.data && form.data.network && form.data.network.availability_domain;
    var oracleHeadNode = form && form.data && form.data.server && form.data.server.instance_id;

    var availabilityHook = useInstanceAvailability({
        provider: 'oracle',
        credentialId: oracleCredentialId,
        region: oracleRegion,
        headNodeInstance: oracleHeadNode,
        computeNodeInstances: computeNodeInstanceTypes,
        enabled: Boolean(oracleCredentialId && oracleRegion)
    });
    var zoneAvailability = availabilityHook.zoneAvailability;
    var isAvailabilityLoading = availabilityHook.isLoading;
    var availabilityError = availabilityHook.error;
    var unableToVerify = availabilityHook.unableToVerify;

    // Oracle zone-level availability (computed)
    var oracleZoneAvailable = null;
    var oracleMissingInstances = [];
    if (!unableToVerify && oracleZone && zoneAvailability) {
        var zoneData = zoneAvailability[oracleZone];
        if (zoneData) {
            oracleZoneAvailable = zoneData.available;
            oracleMissingInstances = zoneData.missingInstances || [];
        }
    }

    // Card styles matching AWS/IBM forms
    var cardStyle = {
        marginBottom: '24px',
        boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)',
        borderRadius: '8px',
        overflow: 'visible'
    };

    var cardHeaderStyle = {
        paddingBottom: '8px',
        backgroundColor: '#f7f9fc'
    };

    var sectionTitleStyle = {
        fontSize: '16px',
        fontWeight: 600,
        color: '#0f2147'
    };

    var inputGroupStyle = {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        marginBottom: '16px',
        alignItems: 'flex-start'
    };

    var tooltipIconStyle = {
        fontSize: '16px',
        marginLeft: '4px',
        color: '#6b778c',
        verticalAlign: 'middle',
        cursor: 'help'
    };

    var columnContainerStyle = {
        display: 'flex',
        flexDirection: 'row',
        gap: '24px',
        width: '100%'
    };

    var columnStyle = {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0
    };

    useEffect(() => {
        if (props.type === 'edit' && form && form.info && form.info.state !== CLUSTER_STATES.DESTROYED) {
            setDisableInputs(true);
        }
    }, [props, form])

    // Load excluded global scripts when editing
    useEffect(() => {
        if (props.type === 'edit' && form) {
            // Check both locations - data.excludedGlobalScripts and root level excludedGlobalScripts
            const excluded = form.data?.excludedGlobalScripts || form.excludedGlobalScripts;
            if (excluded && excluded.length > 0) {
                setExcludedGlobalScripts(excluded);
            }
        }
    }, [props.type, form?.data?.excludedGlobalScripts, form?.excludedGlobalScripts]);

    // Load cluster applications when editing (Feature: cluster-apps)
    useEffect(() => {
        if (props.type === 'edit' && form) {
            const apps = form.applications;
            if (apps && apps.length > 0) {
                setClusterApplications(apps);
            }
        }
    }, [props.type, form?.applications]);

    // Initialize selectedOwner when editing an existing cluster
    useEffect(() => {
        if (props.type === 'edit' && form && form.user && form.user.length > 0) {
            setSelectedOwner(form.user[0]);
        }
    }, [props.type, form]);


    useEffect(() => {
        dispatch(StackActions.getStacks());
        dispatch(getClusterSettings());
    }, [dispatch]);

    useEffect(() => {
        const setVncValues = () => {
            if (form && form.info) {
                setIsVncTokenAuthentication(form.info.vncTokenAuthentication !== undefined ? form.info.vncTokenAuthentication : clusterSettings?.vncTokenAuthentication);
                setIsVncRemoteClient(form.info.vncRemoteClient !== undefined ? form.info.vncRemoteClient : clusterSettings?.vncRemoteClient);
            } else if (clusterSettings) {
                setIsVncTokenAuthentication(clusterSettings.vncTokenAuthentication);
                setIsVncRemoteClient(clusterSettings.vncRemoteClient);
            }
        };

        setVncValues();
    }, [form, clusterSettings]);

    useEffect(() => {
        const names = clustersArr.map(cluster => cluster.name);
        setClusterNames(names);
    }, [clustersArr, setClusterNames]);

    useEffect(() => {
        dispatch(MarketActions.getMarketplaceStacks(marketplaceData))
    }, [dispatch, marketplaceData])

    const setClusterInfo = (e) => {
        setForm(_.set({ ...form }, 'data', { ...form.data, moab: { ...form.data.moab, [e.target.name]: e.target.value } }));
    }
    // lifecycle hook functions
    useEffect(() => {
        if (props.type === 'new') {
            selectedMarketStack ?
                dispatch(Actions.newMarketCluster(selectedMarketStack)) :
                dispatch(Actions.newCluster());
        }
    }, [props.type, dispatch, props.onDemand, selectedMarketStack, currentMarketStack]);

    useEffect(() => {
        if (form?.data.network.region_id) {
            let costNodesTotal = 0;
            let costNode = 0;
            const sps = providers.filter(p => p.id === "oracle");
            
            // Safety check: ensure Oracle provider and instanceSizes exist
            if (!sps[0] || !sps[0].instanceSizes) {
                return;
            }
            
            const headNode = sps[0].instanceSizes.filter(r => r.instance_id === form.data.server.instance_id);
            const costHeadNode = headNode[0]?.cost?.cost_region[form.data.network.region_id];

            form.data.node.group.map(val => {
                const node = sps[0].instanceSizes.filter(r => r.instance_id === val.instance_id);
                const costNodes = node[0]?.cost?.cost_region[form.data.network.region_id];
                if (costNodes) {
                    costNode = costNodes * val.count;
                    costNodesTotal = costNodesTotal + costNode;
                }
                return 0;
            });
            setCost(costNodesTotal + costHeadNode);
        }
    }, [form, providers]);

    useEffect(() => {
        const err = error || props.error;
        if (err && err.type === 'form') {
            const name = { name: err.message };
            formRef.current &&
                formRef.current.updateInputsWithError({
                    ...name
                });
            disableButton();
        }
    }, [error, props.error]);

    useEffect(() => {
        // Initialize imageMode from form data when editing
        if (form?.info?.imageMode) {
            setImageMode(form.info.imageMode);
        }
    }, [form?.info?.imageMode]);

    // Sync node groups with head node settings when in UNIFIED mode
    // In unified mode, all nodes use the same image (head node's image_name)
    useEffect(() => {
        if (imageMode === IMAGE_MODE.UNIFIED && form?.data?.node?.group && form?.data?.server?.image_name) {
            // Update all node groups to use server's image_name as their prefix
            const updatedGroups = form.data.node.group.map(node => ({
                ...node,
                group_node_prefix: form.data.server.image_name
            }));
            
            // Only update if there are actual changes to avoid infinite loops
            const needsUpdate = form.data.node.group.some((node, index) => 
                node.group_node_prefix !== updatedGroups[index].group_node_prefix
            );
            
            if (needsUpdate) {
                setForm(prevForm => ({
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        node: {
                            ...prevForm.data.node,
                            group: updatedGroups
                        }
                    }
                }));
            }
        }
    }, [imageMode, form?.data?.server?.image_name]);

    useEffect(() => {
        if ((cluster && !form) || (cluster && form && cluster.id !== form.id)) {
            setForm(cluster);
        }
    }, [form, cluster, setForm]);

    useEffect(() => {
        if (form?.data.network.region_id) {
            providers.map(
                p =>
                    p.id === "oracle" &&
                    p.regions.map(r => r.zones && r.region_id === form.data.network.region_id && setZones(r.zones))
            );
        }
    }, [providers, form]);

    useEffect(() => {
        if (
            providers &&
            form &&
            (!nodeInstanceSizes || !serverInstanceSizes || !filteredCredentials || !regions || !zones)
        ) {
            const P = providers.find(provider => provider.id === "oracle");
            const InstSizes = P.instanceSizes;
            const Regions = P.regions;
            if (props.type !== 'new') {
                if (InstSizes.filter(s => s.instance_id === form.data.server.instance_id).length === 0) {
                    InstSizes.push({ instance_id: form.data.server.instance_id, name: form.data.server.instance_id, cores: 0 });
                }
                if (Regions.filter(r => r.region_id === form.data.network.region_id).length === 0) {
                    Regions.push({
                        region_id: form.data.network.region_id,
                        name: form.data.network.region_id,
                        zones: [form.data.network.zone_id]
                    });
                }

                for (const gs of form.data.node.group) {
                    let contains = false;
                    for (const s of InstSizes) {
                        if (s.instance_id === gs.instance_id) {
                            contains = true;
                        }
                    }

                    if (!contains) {
                        InstSizes.push({ instance_id: gs.instance_id, name: gs.instance_id, cores: 0 });
                    }
                }
            }
            const C = credentials.filter(cred => cred.provider === "oracle");
            setNodeInstanceSizes(InstSizes);
            setServerInstanceSizes(InstSizes);
            setFilteredCredentials(C);
            setRegions(Regions);
            if (form.data.network.region_id) {
                Regions.map(r => r.zones && r.region_id === form.data.network.region_id && setZones(r.zones));
            }
        }
    }, [
        providers,
        props,
        form,
        credentials,
        nodeInstanceSizes,
        serverInstanceSizes,
        filteredCredentials,
        regions,
        zones
    ]);

    useEffect(() => {
        // Function to set the initial values for the node group and server instance
        const setInitialValues = () => {
            let initialNodeInstanceId = nodeInstanceSizes[0].instance_id;
            let initialServerInstanceId = serverInstanceSizes[0].instance_id;

            if (currentMarketStack) {
                initialNodeInstanceId = currentMarketStack.config?.computeNodeSize?.[0] ?? initialNodeInstanceId;
                initialServerInstanceId = currentMarketStack.config?.instance_type?.[0] ?? initialServerInstanceId;
            }
            form.data.node.group.forEach(groupItem => {
                if (!groupItem.instance_id) {
                    groupItem.instance_id = initialNodeInstanceId
                }
            })
            if (!form.data.server.instance_id) form.data.server.instance_id = initialServerInstanceId
            return { ...form }
        };
        if (form && form.data.node.group.length === 1 && !form.data.node.group[0].instance_id && nodeInstanceSizes) {
            setForm(setInitialValues())
        }
    }, [form, currentMarketStack, nodeInstanceSizes, serverInstanceSizes, setForm]);

    const setNodeObj = useCallback(({ name, value }) => {
        setForm(prevForm => {
            const newData = { ...prevForm.data, node: { ...prevForm.data.node, [name]: value } };
            return { ...prevForm, data: newData };
        });
    }, [setForm]);

    useEffect(() => {
        if (form && form.data.server.disk_type !== form.data.node.disk_type) {
            setNodeObj({ name: 'disk_type', value: form.data.server.disk_type });
        }
    }, [form, setNodeObj]);

    useEffect(() => {
        setProviderVolsize(setinstancesVol("oracle"))
        dispatch(Actions.provider_os_types("oracle"))
    }, [dispatch]);

    useEffect(() => {
        if (form?.data.network.region_id) {
            const sps = providers.filter(p => p.id === "oracle");
            
            // Safety check: ensure Oracle provider and required properties exist
            if (!sps[0] || !sps[0].regions || !sps[0].instanceSizes) {
                return;
            }
            
            const region = sps[0].regions.filter(r => r.region_id === form.data.network.region_id);
            const zone = region[0]?.zones?.filter(
                r => r.zone_id === form.data.network.availability_domain || r.zone_id === form.data.network.zone_id
            );

            const clustersInUse = clustersArr.filter(c => c.info.state !== 'down' && c.provider === "oracle");
            let intances = clustersInUse.length;
            let network = clustersInUse.length;
            let cpus = 0;

            clustersInUse.forEach(c => {
                const fp = providers.filter(p => p.id === c.provider);
                if (!fp[0] || !fp[0].instanceSizes) return;
                //nodes used
                c.data.node.group.forEach(i => {
                    intances = parseInt(intances) + parseInt(i.count);
                    const ccores = fp[0].instanceSizes.filter(co => co.instance_id === i.instance_id);
                    cpus = cpus + parseInt(ccores[0]?.cores || 0) * i.count;
                });
                //server used
                const scores = fp[0].instanceSizes.filter(co => co.instance_id === c.data.server.instance_id);
                cpus = cpus + parseInt(scores[0]?.cores || 0);
            });

            //server edict
            const ecores = sps[0].instanceSizes.filter(co => co.instance_id === form.data.server.instance_id);
            network++;
            intances++;
            cpus = cpus + parseInt(ecores[0]?.cores || 0);

            form.data.node.group.forEach(i => {
                intances = parseInt(intances) + parseInt(i.count);
                const eccores = sps[0].instanceSizes.filter(co => co.instance_id === i.instance_id);
                if (eccores[0]?.cores) cpus = cpus + parseInt(eccores[0].cores) * i.count;
            });

            setUsedCpus(cpus);
            setUsedIntances(intances);
            setUsedNetwork(network);

            zone?.[0]?.quotas?.cpus && setLimitIntances(zone[0]?.quotas?.cpus);
            zone?.[0]?.quotas?.intance && setLimitCpus(zone[0]?.quotas?.intance);
            zone?.[0]?.quotas?.network && setLimitNetwork(zone[0]?.quotas?.network);
        }
    }, [form, providers, clustersArr]);

    // helper functions
    const getDefaultOsType = () => {
        if (supportedOSs.includes(form.info['os-type'])) {
            return form.info['os-type'];
        }
        return supportedOSs[0] || '';
    };

    const handleClose = useCallback(() => {
        dispatch(ActionsDialog.closeDialog());
        dispatch(MarketActions.clearStack());
    }, [dispatch]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleClose]);

    const disableButton = () => setIsFormValid(false);
    const enableButton = () => setIsFormValid(true);
    const handleMenuOpen = (event) => setMenuAnchorEl(event.currentTarget);
    const handleMenuClose = () => setMenuAnchorEl(null);

    const handleGroupNodeMenuItemClick = (index, selectedPrefix) => {
        setGroupNodeInputValues(prevValues => ({
            ...prevValues,
            [index]: selectedPrefix
        }));
        setNodePrefix(index, selectedPrefix);
        setActiveMenuIndex(null);
    };

    const handleGroupNodeMenuOpen = (index) => setActiveMenuIndex(index);

    const handleDeletePackages = pkg => {
        const filteredPkgs = form.data.packages.filter(p => p !== pkg);
        setDataObj({ name: 'packages', value: filteredPkgs });
        const isInPkgs = form.data.packages.some(p => p === pkg);
        const isInDeletedPkgs = deletedPkgs.some(dp => dp === pkg);
        if (isInPkgs && !isInDeletedPkgs) {
            const delArr = form.data.packages.filter(p => p === pkg);
            setDeletedPkgs([...deletedPkgs, ...delArr]);
        }
    };

    const setDataObj = ({ name, value }) => setForm(_.set({ ...form }, 'data', { ...form.data, [name]: value }));

    const setNetworkObj = ({ name, value }) => {
        setForm(_.set({ ...form }, 'data', { ...form.data, network: { ...form.data.network, [name]: value } }));
    };

    const combineSameConfigurationNodes = groups => {
        const seenGroups = {};
        groups.forEach(group => {
            const compositeId = `${group.group_node_prefix_label}-${group.group_node_prefix}-${group.instance_id}-${group.ocpu}-${group.mem}`;
            if (compositeId in seenGroups)
                seenGroups[compositeId].count = parseInt(seenGroups[compositeId].count) + parseInt(group.count);
            else seenGroups[compositeId] = group;
        });
        const filteredGroups = Object.keys(seenGroups).map(key => seenGroups[key]);
        return filteredGroups;
    };

    const setInstanceId = (i = 0, value) => {
        //Fix the issue of entering wrong CPUS and MEM for Flex instance will not allow you to Save the Cluster info if the user
        //decided to choose a normal / NON Flex instance
        const groups = form.data.node.group;
        groups[i]['instance_id'] = value;
        if (!value.includes('Flex')) {
            setNodeOCPUS(i, 1);
            setNodeMEM(i, 1);
        }
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const setNodePrefix = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['group_node_prefix'] = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };
    const setNodePrefixLabel = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['group_node_prefix_label'] = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    }

    const setNodeMEM = (i, value) => {
        const groups = form.data.node.group;
        groups[i].mem = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const marketplaceOSTypes = currentMarketStack?.config?.os_types;
    const marketplaceInstanceIds = currentMarketStack?.config?.instance_type;
    const marketplaceComputeIds = currentMarketStack?.config?.computeNodeSize;
    const marketplaceRegionIds = currentMarketStack?.config?.allowed_regions;

    // TODO: I implemented this the way that other things are currently being implemented.
    // This could be refactored.
    const setMigMode = (instance_id, mode) => {
        if (!form.data.node.mig_config) form.data.node.mig_config = [];
        if (form.data.node.mig_config.length === 0) {
            const mig_config = [];
            mig_config.push({
                instance_id: instance_id,
                mig_mode: mode
            });
            form.data.node.mig_config = mig_config;
        }
        form.data.node.mig_config = form.data.node.mig_config.map(config => {
            if (config.instance_id === instance_id) {
                config.mig_mode = mode;
            }
            return config;
        });
        setForm({ ...form });
    };


    const setInstanceCount = (i, { name, value }) => {
        const group = form.data.node.group;
        group[i][name] = value;

        const groupFiltered = combineSameConfigurationNodes(group);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };

    const setServerObj = ({ name, value }) => {
        //Fix the issue of entering wrong CPUS and MEM for Flex instance will not allow you to Save the Cluster info if the user
        //decided to choose a normal / NON Flex instance
        if (name === 'instance_id' && !value.includes('Flex')) {
            form.data.server.ocpus = form.data.server.mem = 1;
            setForm(_.set({ ...form }, 'data', { ...form.data, server: { ...form.data.server, [name]: value } }));
        } else {
            setForm(_.set({ ...form }, 'data', { ...form.data, server: { ...form.data.server, [name]: value } }));
        }
    };

    const setInfoObj = ({ name, value }) => {
        setForm(_.set({ ...form }, 'info', { ...form.info, [name]: value }));
    };

    const setNodeOCPUS = (i, value) => {
        const groups = form.data.node.group;
        groups[i].ocpus = value;
    };

    const setPackagesArr = () => {
        const pkg = pkgRef.current.value;
        setForm(_.set({ ...form }, 'data', { ...form.data, packages: [...form.data.packages, pkg] }));
        pkgRef.current.value = null;
    };

    const handleUpload = e => {
        const file = e.target.files[0];
        if (!file) return;

        //reset value to '' so that the same file can be uploaded if removed
        e.target.value = '';

        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
            setForm(
                _.set({ ...form }, 'data', { ...form.data, provision: { ...form.data.provision, script: reader.result } })
            );
        };
    };

    const areNonFormsyRequiredFieldsValid = () => {
        // check that the server prefix and all of the prefixes of compute nodes are in a non-error state and have content
        const serverPrefixisValid = !prefixError && form.data.server.image_name
        const nodePrefixesAreValid = nodePrefixErrors.every(error => error === '') && form.data.node.group.every(node => node.group_node_prefix)
        return serverPrefixisValid && nodePrefixesAreValid
    }

    //Validation functions
    const validationInput = (type, instanceid, currentvalue, ocpus, provider, currentMarketStack) => {
        return validationInputUlt(type, instanceid, currentvalue, ocpus, provider, currentMarketStack);
    };

    const validationMess = (type, instanceid, ocpus, provider, currentMarketStack) => {
        return validationMessUlt(type, instanceid, ocpus, provider, currentMarketStack);
    };

    const handleDeleteScript = () => {
        setForm(_.set({ ...form }, 'data', { ...form.data, provision: { ...form.data.provision, script: '' } }));
    }

    const addComputeNode = () => {
        if (form.data.node.group.length < 250) {
            // In unified mode, use server's image_name as the node prefix
            const unifiedPrefix = imageMode === IMAGE_MODE.UNIFIED ? form.data.server.image_name : '';
            
            const initialValues = { 
                ...form.data.node.group[0], 
                count: 1,
                group_node_prefix: unifiedPrefix || form.data.node.group[0].group_node_prefix,
                group_node_prefix_label: `Node Group ${form.data.node.group.length + 1}`
            };
            setForm((prevForm) => ({
                ...prevForm, data: { ...prevForm.data, node: { ...prevForm.data.node, group: [...prevForm.data.node.group, initialValues] } }
            }
            ));
        }
    }
    const removeComputeNode = (i) => {
        if (form.data.node.group.length > 1) {
            setForm((prevForm) => {
                const group = [...prevForm.data.node.group]
                group.splice(i, 1)
                return { ...prevForm, data: { ...prevForm.data, node: { ...prevForm.data.node, group } } }
            })
        }
    }

    const handleEdit = ({ confirmed }) => {
        if (confirmed) {
            dispatch(ActionsDialog.closeDialog());
        }
        if (error) {
            dispatch(Actions.clearError());
        }
        //reset lastDeployTime & lastDestroyTime
        if (form?.info?.lastDeployTime) form.info.lastDeployTime = 0;
        if (form?.info?.lastDestroyTime) form.info.lastDestroyTime = 0;

        form.data.node.group.forEach(node => {
            if (node.group_node_prefix === '') node.group_node_prefix = form.info.prefix
        });

        // Include excluded global scripts at root level (Feature 002 enhancement)
        form.excludedGlobalScripts = excludedGlobalScripts;

        // Include cluster applications (Feature: cluster-apps)
        form.applications = clusterApplications || [];

        // Set imageMode in info object (matches schema)
        form.info.imageMode = imageMode;

        // Add owner selection if super-admin selected a different owner
        const editData = { cluster: form };
        if (currentUser.role && currentUser.role.includes('super-admin') && selectedOwner) {
            editData.ownerUsername = selectedOwner;
        }

        dispatch(Actions.editCluster(editData.cluster, deletedPkgs, editData.ownerUsername));
    };

    const handleSave = ({ confirmed }) => {
        if (props.setOldForm) {
            props.setOldForm(form);
        }
        if (confirmed) {
            dispatch(ActionsDialog.closeDialog());
        }

        const updatedForm = {
            ...form,
            excludedGlobalScripts,
            applications: clusterApplications || [],
            data: {
                ...form.data,
            },
            info: {
                ...form.info,
                isMarketplace: isMarketStack,
                server_ocid: currentMarketStack?.config?.server_ocid,
                node_ocid: currentMarketStack?.config?.node_ocid,
                "os-type": form.info['os-type'],
                vncTokenAuthentication: isVncTokenAuthentication,
                vncRemoteClient: isVncRemoteClient,
                imageMode: imageMode,
                // Preserve unifiedImageId from form (set from stack during creation)
                unifiedImageId: form.info?.unifiedImageId || null
            },
            provider: "oracle"
        };
        setForm(updatedForm);
        updatedForm.data.node.group.forEach(node => {
            if (node.group_node_prefix === '') node.group_node_prefix = updatedForm.info.prefix;
        });
        
        // Add owner selection if super-admin selected a different owner
        const saveData = { ...updatedForm };
        if (currentUser.role && currentUser.role.includes('super-admin') && selectedOwner) {
            saveData.ownerUsername = selectedOwner;
        }
        
        setForm(updatedForm)
        dispatch(Actions.saveCluster(saveData));

    };

    const startSave = () => handleSave({ confirmed: false });
    const startEdit = () => handleEdit({ confirmed: false });

    const handlePopoverOpen = (event, popoverId) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const isODDCBurstingSelectionEnabled = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/moab/isIntegrated`)
            if (response.status !== 200) return false
            return response.data.isIntegrated
        } catch (error) {
            console.error('Error fetching from API:', error)
        }
    }

    const [moabIsIntegrated, setMoabIsIntegrated] = useState(null);

    useEffect(() => {
        const fetchDataAsync = async () => {
            const isIntegrated = await isODDCBurstingSelectionEnabled();
            setMoabIsIntegrated(isIntegrated);
        };

        fetchDataAsync();
    }, []);

    const [burstMode, setBurstMode] = useState(null)

    useEffect(() => {
        // Assuming `form.data.node.group` is an array of objects and each object has a `group_node_prefix`
        const initialValues = form?.data?.node?.group.map(group => group.group_node_prefix || '');
        setGroupNodeInputValues(initialValues);
    }, [form]);

    useEffect(() => {
        if (burstMode !== null) return
        if (props.type === 'new') {
            if (currentMarketStack ?
                setBurstMode('off') : setBurstMode('max'));
            return
        }
        if (form?.info?.bursting?.mode) setBurstMode(form.info.bursting.mode)
    }, [form, currentMarketStack, props.type, burstMode]);

    useEffect(() => {
        if (burstMode === null) return
        if (!form?.info) return
        form.info.bursting.mode = burstMode
    }, [form, burstMode]);

    // Reset burst mode when manager changes from Torque to something else
    useEffect(() => {
        if (form?.data?.manager && form.data.manager !== RESOURCE_MANAGER.TORQUE && burstMode !== 'off') {
            setBurstMode('off');
            if (form?.info?.bursting) {
                form.info.bursting.mode = 'off';
            }
        }
    }, [form?.data?.manager, burstMode]);

    // Clear Moab data when manager changes away from Torque
    useEffect(() => {
        if (form?.data?.manager && form.data.manager !== RESOURCE_MANAGER.TORQUE) {
            if (form.data.moab && (form.data.moab.hostname || form.data.moab.ip)) {
                setForm(prevForm => ({
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        moab: {
                            ...prevForm.data.moab,
                            hostname: '',
                            ip: ''
                        }
                    }
                }));
            }
        }
    }, [form?.data?.manager, setForm]);

    const validateServerPrefix = (prefix) => { // Since "Node Prefix" field is not a "Formsy" input. This is how we need to show validations.
        const invalidPrefixCharacter = 'Invalid characters in the prefix. Use only lowercase letters, numbers, and hyphens.';
        const invalidPrefixHyphenUsage = 'Hyphens cannot start or end the prefix, and consecutive hyphens are not allowed.';
        if (/[^a-z0-9-]/g.test(prefix)) setPrefixError(invalidPrefixCharacter);
        else if (/^-|-$|--/g.test(prefix)) setPrefixError(invalidPrefixHyphenUsage);
        else setPrefixError('');
    }

    const validateNodePrefix = (prefix, index) => {
        const invalidPrefixCharacter = 'Invalid characters in the prefix. Use only lowercase letters, numbers, and hyphens.';
        const invalidPrefixHyphenUsage = 'Hyphens cannot start or end the prefix, and consecutive hyphens are not allowed.';
        let error = '';
        if (/[^a-z0-9-]/g.test(prefix)) error = invalidPrefixCharacter;
        else if (/^-|-$|--/g.test(prefix)) error = invalidPrefixHyphenUsage;

        setNodePrefixErrors(prevErrors => {
            const newErrors = [...prevErrors];
            newErrors[index] = error;
            return newErrors;
        });
    };

    return (
        <React.Fragment>
            {form && (
                <React.Fragment>
                    <DialogTitle className={clsx(classes.modalHeader, 'h-54 min-h-54 p-20')}>
                        <div className="flex flex-1 w-full items-center justify-between">
                            <div className="flex flex-col max-w-full">
                                <div className="flex items-center max-w-full">
                                    <img
                                        id="oracle_provider-logo"
                                        className="w-32 sm:w-48 mr-8 sm:mr-16 rounded"
                                        src={imageSrc} alt="Provider Logo"
                                    />
                                    <div className="flex flex-col min-w-0">
                                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Typography id="oracle_cluster-name-header" className="text-16 text-white sm:text-20 truncate">
                                                    {title} {props.type === 'edit' && form?.id && (
                                                        <span className='text-12 text-gray-400'>ID: {form.id}</span>
                                                    )}
                                                </Typography>
                                            </div>
                                        </FuseAnimate>
                                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                            <Typography id="oracle_provider-name" className="text-white" variant="caption">
                                                {'Oracle'}
                                            </Typography>
                                        </FuseAnimate>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Button
                                    className="whitespace-no-wrap mr-2"
                                    id="oracle_advanced-btn"
                                    variant="contained"
                                    disabled={loading}
                                    onClick={() => setAdvanced(!advanced)}
                                >
                                    Advanced
                                </Button>
                                {props.type === 'new' && (
                                    <Button
                                        className="whitespace-no-wrap mx-2"
                                        id="oracle_save-btn"
                                        disabled={
                                            !isFormValid ||
                                            !areNonFormsyRequiredFieldsValid()
                                            // !isFormValid || nodePrefixError.length ||
                                            // loading ||
                                            // (form.name && clusterNames.includes(form.name)) ||
                                            // !form.data.server.image_name
                                        }
                                        variant="contained"
                                        onClick={() => {
                                            startSave();
                                            dispatch(MarketActions.clearStack());
                                        }}
                                    >
                                        {'Save'}
                                    </Button>
                                )}
                                {props.type === 'edit' && form.info.state === CLUSTER_STATES.DESTROYED && (
                                    <Button
                                        className="whitespace-no-wrap mx-2"
                                        id="oracle_save-btn"
                                        disabled={!isFormValid || loading || !form.data.server.image_name}
                                        variant="contained"
                                        onClick={() => {
                                            startEdit()
                                            dispatch(MarketActions.clearStack())
                                        }}
                                    >
                                        update
                                    </Button>
                                )}
                                <Button
                                    className="whitespace-no-wrap ml-2"
                                    id="oracle_close-btn"
                                    variant="contained"
                                    onClick={handleClose}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </DialogTitle>
                    {usedCpus > limitCpus && (
                        <DialogContent className={clsx(classes.content, 'flex flex-col items-center max-w-full p-16 ')}>
                            <span className={classes.error2}>
                                <Icon>error</Icon> <span>The quota of CPUs established by the provider is exceeded</span>
                            </span>
                        </DialogContent>
                    )}
                    {usedNetwork > limitNetwork && (
                        <DialogContent className={clsx(classes.content, 'flex flex-col items-center max-w-full p-16 ')}>
                            <span className={classes.error2}>
                                <Icon>error</Icon> <span>The quota of network established by the provider is exceeded</span>
                            </span>
                        </DialogContent>
                    )}
                    {usedIntances > limitIntances && (
                        <DialogContent className={clsx(classes.content, 'flex flex-col items-center max-w-full p-16 ')}>
                            <span className={classes.error2}>
                                <Icon>error</Icon> <span>The quota of Intances established by the provider is exceeded</span>
                            </span>
                        </DialogContent>
                    )}
                    <DialogContent className={clsx(classes.content, 'flex flex-col justify-start items-center max-w-full p-16')}>
                        <DisabledFormWrapper isDisabled={disableInputs}>
                            <Formsy ref={formRef} onValid={enableButton} onInvalid={disableButton}>
                                {/* Owner Selection Card - Only for Super Admin in Advanced Mode */}
                                <OwnerSelectionCard
                                    value={selectedOwner}
                                    onChange={setSelectedOwner}
                                    label="Cluster Owner"
                                    title="Cluster Owner"
                                    showInAdvancedMode={true}
                                    advanced={advanced}
                                    disabled={props.type === 'edit' && form && form.info && form.info.state !== CLUSTER_STATES.DESTROYED}
                                />
                                
                                {/* Basic Information Card */}
                                <Card style={cardStyle}>
                                    <CardHeader
                                        title={
                                            <Box display="flex" alignItems="center">
                                                <Icon style={{marginRight: '8px', color: '#2196F3'}}>info</Icon>
                                                <Typography style={sectionTitleStyle}>Basic Information</Typography>
                                            </Box>
                                        }
                                        style={cardHeaderStyle}
                                    />
                                    <CardContent>
                                <div className="flex flex-row my-16 w-full">
                                    <TextFieldFormsy
                                        className={clsx(classes.input, 'mr-8')}
                                        id="oracle_name"
                                        name="name"
                                        label="Cluster Name"
                                        type="text"
                                        variant="outlined"
                                        value={form.name}
                                        onChange={handleChange}
                                        fullWidth
                                        required
                                        placeholder="Your Cluster Name (No Spaces or Capitals)"
                                        validations={{
                                            isNameUnique: (formValues, fieldValue) => {
                                                if (clusterNames.includes(fieldValue) && !(props.type === 'edit')) {
                                                    return 'This name is already in use. Please choose a different one.';
                                                }
                                                return true;
                                            },
                                            isString: (formValues, fieldValue) => typeof fieldValue === 'string' || 'Name must be a string.',
                                            doesNotExceedMaxLength: (formValues, fieldValue) =>
                                                !fieldValue || fieldValue.length <= 15 || 'Name cannot exceed 15 characters.',
                                            hasValidCharacters: (formValues, fieldValue) =>
                                                !fieldValue || !/[^a-z0-9-]/g.test(fieldValue) || 'Invalid characters in the name. Use only lowercase letters, numbers, and hyphens.',
                                            doesNotStartOrEndWithHyphen: (formValues, fieldValue) =>
                                                !fieldValue || !/^-|-$|--/g.test(fieldValue) || 'Hyphens cannot start or end the name, and consecutive hyphens are not allowed.',
                                            doesNotStartWithInteger: (formValues, fieldValue) =>
                                                !fieldValue || !/^\d/.test(fieldValue) || 'Name cannot start with a number.',
                                        }}
                                        validationErrors={{
                                            isNameUnique: 'This name is already in use. Please choose a different one.',
                                            isString: 'Name must be a string.',
                                            doesNotExceedMaxLength: 'Name cannot exceed 15 characters.',
                                            hasValidCharacters: 'Invalid characters in the name. Use only lowercase letters, numbers, and hyphens.',
                                            doesNotStartOrEndWithHyphen: 'Hyphens cannot start or end the name, and consecutive hyphens are not allowed.',
                                            doesNotStartWithInteger: 'Name cannot start with a number.'
                                        }}
                                    />
                                    <SelectFormsy
                                        className={clsx(classes.input, 'w-1/3 mx-8')}
                                        id="oracle_os-type"
                                        name="os-type"
                                        label="OS Type *"
                                        type="select"
                                        variant="outlined"
                                        value={getDefaultOsType()}
                                        onChange={e => setInfoObj(e.target)}
                                        fullWidth
                                        required
                                        MenuProps={{
                                            PaperProps: {
                                                style: { maxHeight: 300 }
                                            }
                                        }}
                                    >
                                        {
                                            supportedOSs
                                                .filter(os => !marketplaceOSTypes || marketplaceOSTypes.includes(os))
                                                .map((os, index) => (
                                                    <MenuItem
                                                        id={`os-${os}`}
                                                        key={index}
                                                        value={os}
                                                    >
                                                        {os}
                                                    </MenuItem>
                                                ))
                                        }
                                    </SelectFormsy>
                                    <TextField
                                        ref={textFieldRef}
                                        label="Prefix"
                                        className={clsx(classes.input, 'flex-grow', 'ml-8')}
                                        placeholder="Your Prefix Name or Select Stack"
                                        required
                                        value={form.data.server.image_name || ""}
                                        onChange={e => {
                                            form.data.server.image_name = e.target.value
                                            setForm({ ...form }) //done for rerender
                                            validateServerPrefix(e.target.value)
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        error={prefixError ? true : false}
                                        helperText={prefixError}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <IconButton
                                                        disabled={currentMarketStack ? true : false}
                                                        onClick={handleMenuOpen}>
                                                        <ArrowDropDownIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <Menu
                                        anchorEl={textFieldRef.current}
                                        keepMounted
                                        open={Boolean(menuAnchorEl)}
                                        onClose={handleMenuClose}
                                        PaperProps={{
                                            style: {
                                                width: textFieldRef.current ? textFieldRef.current.clientWidth : 'auto',
                                                maxHeight: 200,
                                                overflow: 'auto'
                                            }
                                        }}
                                    >
                                        {
                                            stacks
                                                .filter(stack => stack.info?.state === "success" && stack?.provider === "oracle")
                                                .length > 0
                                                ? stacks
                                                    .filter(stack => stack.info?.state === "success" && stack?.provider === "oracle")
                                                    .map((stack, index) => (
                                                        <MenuItem
                                                            key={index}
                                                            onClick={() => {
                                                                form.data.server.image_name = stack.data.prefix
                                                                setForm({ ...form }) // done for rerender
                                                                handleMenuClose()
                                                            }}
                                                        >
                                                            {stack.data.prefix}
                                                        </MenuItem>
                                                    ))
                                                : <MenuItem disabled>No stack builds available for this provider</MenuItem>
                                        }
                                    </Menu>

                                </div>
                                <div className="flex flex-row my-16 w-full" style={{ alignItems: 'center' }}>
                                    <SelectFormsy
                                        className={clsx(classes.input)}
                                        id="oracle_image_mode"
                                        name="image_mode"
                                        label="Image Mode"
                                        type="select"
                                        variant="outlined"
                                        value={imageMode}
                                        onChange={e => setImageMode(e.target.value)}
                                        style={{ width: '220px' }}
                                        disabled={Boolean(currentMarketStack)}
                                    >
                                        <MenuItem value={IMAGE_MODE.MULTI_IMAGE}>Multi-Image (Legacy)</MenuItem>
                                        <MenuItem value={IMAGE_MODE.UNIFIED}>Unified (Single Image)</MenuItem>
                                    </SelectFormsy>
                                    <Typography variant="body2" color="textSecondary" style={{ marginLeft: '16px' }}>
                                        {imageMode === IMAGE_MODE.UNIFIED
                                            ? 'Single unified image for head and compute nodes'
                                            : 'Separate images for head node and compute nodes'}
                                    </Typography>
                                </div>
                                    </CardContent>
                                </Card>

                                {/* Two-column layout: Infrastructure and Resource Manager */}
                                <div style={columnContainerStyle}>
                                    {/* Left Column - Infrastructure */}
                                    <div style={columnStyle}>
                                        <Card style={cardStyle}>
                                            <CardHeader
                                                title={
                                                    <Box display="flex" alignItems="center">
                                                        <Icon style={{marginRight: '8px', color: '#2196F3'}}>cloud</Icon>
                                                        <Typography style={sectionTitleStyle}>Infrastructure</Typography>
                                                        <Tooltip title="The available Regions, Availability Zones, and Instance Sizes may vary based on your Oracle Cloud account status.">
                                                            <Icon style={tooltipIconStyle}>help_outline</Icon>
                                                        </Tooltip>
                                                    </Box>
                                                }
                                                action={
                                                    oracleZone ? (
                                                        <ZoneAvailabilityIndicator
                                                            isLoading={isAvailabilityLoading}
                                                            isAvailable={oracleZoneAvailable}
                                                            missingInstances={oracleMissingInstances}
                                                            error={availabilityError}
                                                            unableToVerify={unableToVerify}
                                                        />
                                                    ) : null
                                                }
                                                style={cardHeaderStyle}
                                            />
                                            <CardContent>
                                <div className="flex flex-row my-16 w-full">
                                    <SelectFormsy
                                        className={clsx(classes.input, 'w-1/2 mr-8')}
                                        id="oracle_credential_id"
                                        name="credential_id"
                                        label="Oracle Credentials"
                                        type="select"
                                        variant="outlined"
                                        value={form.credential_id}
                                        onChange={handleChange}
                                        fullWidth
                                        required
                                        MenuProps={{
                                            PaperProps: {
                                                style: { maxHeight: 300 }
                                            }
                                        }}
                                    >
                                        {filteredCredentials.map((c, i) => (
                                            <MenuItem id={c.name} key={i} value={c.id}>
                                                {c.name}
                                            </MenuItem>
                                        ))}
                                    </SelectFormsy>
                                    <SelectFormsy
                                        className={clsx(classes.input, 'w-1/2 ml-8')}
                                        id="oracle_server-instance_id"
                                        name="instance_id"
                                        label="Head Node Size *"
                                        type="select"
                                        variant="outlined"
                                        value={form.data.server.instance_id}
                                        onChange={e => setServerObj(e.target)}
                                        fullWidth
                                        required
                                        MenuProps={{
                                            PaperProps: {
                                                style: { maxHeight: 300 }
                                            }
                                        }}
                                    >
                                        {
                                            serverInstanceSizes
                                                .filter(s => !marketplaceInstanceIds || marketplaceInstanceIds.includes(s.instance_id))
                                                .map((s, i) => (
                                                    <MenuItem
                                                        id={`server-${s.name}`}
                                                        key={i}
                                                        value={s.instance_id}
                                                    >
                                                        {s.name}
                                                    </MenuItem>
                                                ))
                                        }
                                    </SelectFormsy>
                                </div>
                                <div className="flex flex-row my-16 w-full">
                                    <SelectFormsy
                                        className={clsx(classes.input, 'w-full mr-8')}
                                        id="oracle_region_id"
                                        name="region_id"
                                        label="Region *"
                                        type="select"
                                        variant="outlined"
                                        value={form.data.network.region_id}
                                        onChange={e => setNetworkObj(e.target)}
                                        fullWidth
                                        required
                                        MenuProps={{
                                            PaperProps: {
                                                style: { maxHeight: 300 }
                                            }
                                        }}
                                    >
                                        {
                                            regions
                                                .filter(region => !marketplaceRegionIds || marketplaceRegionIds.includes(region.region_id))
                                                .map((region, index) => (
                                                    <MenuItem
                                                        id={`region-${region.name}`}
                                                        key={index}
                                                        value={region.region_id}
                                                    >
                                                        {region.name}
                                                    </MenuItem>
                                                ))
                                        }
                                    </SelectFormsy>

                                    <TextFieldFormsy
                                        className={clsx(classes.input, 'w-full ml-8')}
                                        id="oracle_availability_domain"
                                        name="availability_domain"
                                        label="Availability Zone"
                                        type="text"
                                        variant="outlined"
                                        value={form.data.network.availability_domain}
                                        onChange={e => setNetworkObj(e.target)}
                                        fullWidth
                                        required
                                        placeholder="Example: ABCD:US-ASHBURN-AD-1"
                                    />

                                    {advanced && (
                                        <TextFieldFormsy
                                            className={clsx(classes.input, 'ml-16')}
                                            id="oracle_security_group_id"
                                            name="security_group_id"
                                            label="Security List ID"
                                            type="text"
                                            variant="outlined"
                                            value={form.data.network.security_group_id}
                                            onChange={e => setNetworkObj(e.target)}
                                            fullWidth
                                            placeholder="Expample: ocid1.securitylist.oc1.iad.aaaa"
                                        />
                                    )}
                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    
                                    {/* Right Column - Resource Manager Configuration */}
                                    <div style={columnStyle}>
                                        <Card style={cardStyle}>
                                            <CardHeader
                                                title={
                                                    <Box display="flex" alignItems="center">
                                                        <Icon style={{marginRight: '8px', color: '#2196F3'}}>settings</Icon>
                                                        <Typography style={sectionTitleStyle}>Resource Manager Configuration</Typography>
                                                    </Box>
                                                }
                                                style={cardHeaderStyle}
                                            />
                                            <CardContent>
                                                {/* Manager Selection */}
                                                <div className='flex gap-4 mb-16'>
                                                    <SelectFormsy
                                                        className={clsx(classes.input, "flex-1")}
                                                        id="oracle_manager"
                                                        name="manager"
                                                        label="Manager"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.data.manager}
                                                        disabled={currentMarketStack ? true : false}
                                                        onChange={e => setDataObj(e.target)}
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 200 }
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem id="oracle_none" value="none">
                                                            None
                                                        </MenuItem>
                                                        <MenuItem id="oracle_slurm" value="slurm">
                                                            Slurm
                                                        </MenuItem>
                                                        <MenuItem id="oracle_torque" value="torque">
                                                            Torque
                                                        </MenuItem>
                                                        <MenuItem id="oracle_pbspro" disabled value="pbspro">
                                                            PBSPro - Not yet implemented
                                                        </MenuItem>
                                                        <MenuItem id="oracle_lsf" disabled value="lsf">
                                                            LSF - Not yet implemented
                                                        </MenuItem>
                                                    </SelectFormsy>
                                                </div>

                                                {/* Moab Configuration */}
                                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: '12px' }}>Moab Configuration</Typography>
                                                <div style={inputGroupStyle}>
                                                    <TextField
                                                        className={clsx(classes.input)}
                                                        style={{ flex: 1 }}
                                                        id="oracle_hostname"
                                                        name="hostname"
                                                        label="Hostname"
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.moab.hostname || ''}
                                                        fullWidth
                                                        required={form.data.manager === RESOURCE_MANAGER.TORQUE}
                                                        disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                        placeholder="Host Name"
                                                        onChange={e => setClusterInfo(e)}
                                                        InputProps={{
                                                            readOnly: form.data.manager !== RESOURCE_MANAGER.TORQUE,
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledInput : '',
                                                                notchedOutline: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledOutline : '',
                                                            },
                                                            style: {
                                                                pointerEvents: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'none' : 'auto'
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledLabel : ''
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'rgba(0, 0, 0, 0.38)' : 'inherit'
                                                            }
                                                        }}
                                                    />
                                                    <TextField
                                                        className={clsx(classes.input)}
                                                        style={{ flex: 1 }}
                                                        id="oracle_ip"
                                                        name="ip"
                                                        label={form.data.server.isPrivate ? 'Private IP' : 'Public IP'}
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.moab.ip || ''}
                                                        fullWidth
                                                        required={form.data.manager === RESOURCE_MANAGER.TORQUE}
                                                        disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                        placeholder={form.data.server.isPrivate ? 'Private IP' : 'Public IP'}
                                                        onChange={e => setClusterInfo(e)}
                                                        InputProps={{
                                                            readOnly: form.data.manager !== RESOURCE_MANAGER.TORQUE,
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledInput : '',
                                                                notchedOutline: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledOutline : '',
                                                            },
                                                            style: {
                                                                pointerEvents: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'none' : 'auto'
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledLabel : ''
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'rgba(0, 0, 0, 0.38)' : 'inherit'
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                {/* Bursting Configuration */}
                                                {moabIsIntegrated && form.data.manager === RESOURCE_MANAGER.TORQUE && (
                                                    <React.Fragment>
                                                        <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: '8px', marginTop: '8px' }}>Bursting Configuration</Typography>
                                                        <FormControl component="fieldset" className={classes.formControl}>
                                                            <RadioGroup
                                                                id="oracle_burstOnDeploy"
                                                                row
                                                                name="burstOnDeploy"
                                                                value={burstMode}
                                                                onChange={function(e) {
                                                                    var mode = e.target.value;
                                                                    setBurstMode(mode);
                                                                }}
                                                            >
                                                                <FormControlLabel value="off" id="oracle_radio-off" control={<Radio />} label="Off" />
                                                                <FormControlLabel value="min" id="oracle_radio-min" control={<Radio />} label="Min" />
                                                                <FormControlLabel value="max" id="oracle_radio-max" control={<Radio />} label="Max" />
                                                                <FormControlLabel value="all" id="oracle_radio-all" control={<Radio />} label="All" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </React.Fragment>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>

                                {/* Flex Instance Configuration Card */}
                                {form.data.server.instance_id.includes('Flex') && (
                                    <Card style={cardStyle}>
                                        <CardHeader
                                            title={
                                                <Box display="flex" alignItems="center">
                                                    <Icon style={{marginRight: '8px', color: '#2196F3'}}>memory</Icon>
                                                    <Typography style={sectionTitleStyle}>Flex Instance Configuration</Typography>
                                                </Box>
                                            }
                                            style={cardHeaderStyle}
                                        />
                                        <CardContent>
                                            <div style={inputGroupStyle}>
                                                <TextFieldFormsy
                                                    className={clsx(classes.input)}
                                                    style={{ flex: 1 }}
                                                    id="oracle_ocpus"
                                                    name="ocpus"
                                                    label="Server Cores (OCPUs)"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.server.ocpus}
                                                    required
                                                    onChange={e => setServerObj(e.target)}
                                                    fullWidth
                                                    validations={{
                                                        hasCharactersOrZero: function(formValues, fieldValue) {
                                                            return validationInput(
                                                                'ocpus',
                                                                formValues.instance_id,
                                                                fieldValue,
                                                                formValues.mem,
                                                                "oracle"
                                                            );
                                                        }
                                                    }}
                                                    validationErrors={{
                                                        hasCharactersOrZero: validationMess(
                                                            'ocpuserror',
                                                            form.data.server.instance_id,
                                                            form.data.server.ocpus,
                                                            "oracle"
                                                        )
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className={clsx(classes.input)}
                                                    style={{ flex: 1 }}
                                                    id="oracle_mem"
                                                    name="mem"
                                                    label="Server Memory (GB)"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.server.mem}
                                                    required
                                                    onChange={e => setServerObj(e.target)}
                                                    fullWidth
                                                    validations={{
                                                        mustBeEqualOrGreaterThanOCPUS: function(formValues, fieldValue) {
                                                            return validationInput(
                                                                'mem',
                                                                formValues.instance_id,
                                                                fieldValue,
                                                                formValues.ocpus,
                                                                "oracle"
                                                            );
                                                        }
                                                    }}
                                                    validationErrors={{
                                                        mustBeEqualOrGreaterThanOCPUS: validationMess(
                                                            'memerror',
                                                            form.data.server.instance_id,
                                                            form.data.server.ocpus,
                                                            "oracle"
                                                        )
                                                    }}
                                                />
                                            </div>
                                        </CardContent>
                                    </Card>
                                )}

                                {/* Advanced Settings Card */}
                                {advanced && (
                                    <Card style={cardStyle}>
                                        <CardHeader
                                            title={
                                                <Box display="flex" alignItems="center">
                                                    <Icon style={{marginRight: '8px', color: '#2196F3'}}>tune</Icon>
                                                    <Typography style={sectionTitleStyle}>Advanced Settings</Typography>
                                                </Box>
                                            }
                                            style={cardHeaderStyle}
                                        />
                                        <CardContent>
                                            {/* Network Configuration */}
                                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: '12px' }}>Network Configuration</Typography>
                                            <div style={inputGroupStyle}>
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'w-1/4 mr-8')}
                                                    id="oracle_LPG"
                                                    name="LPG"
                                                    label={form.data.server.isPrivate ? '*LPG Name' : 'LPG Name'}
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.LPG}
                                                    onChange={e => setDataObj(e.target)}
                                                    fullWidth
                                                    placeholder="Local Peering Gateway Name"
                                                />
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'w-1/4 ml-8')}
                                                    id="oracle_vcn_cidr"
                                                    name="vcn_cidr"
                                                    label="VCN CIDR"
                                                    type="text"
                                                    required={Boolean(form.data.network.vcn_id)}
                                                    variant="outlined"
                                                    value={form.data.vcn_cidr}
                                                    onChange={e => setDataObj(e.target)}
                                                    fullWidth
                                                    placeholder="Example: 172.31.0.0/16"
                                                    validations={{
                                                        mustbeip: (formValues, fieldValue) => {
                                                            return validationInput('PrivateIP', formValues.instance_id, fieldValue, 1, "oracle")
                                                        },
                                                    }}
                                                    validationErrors={{
                                                        mustbeip: validationMess('PrivateIP', form.instance_id, 1, "oracle"),
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'w-1/4 ml-16')}
                                                    id="oracle_local_cidr"
                                                    name="local_cidr"
                                                    label="Local CIDR"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.local_cidr}
                                                    onChange={e => setDataObj(e.target)}
                                                    fullWidth
                                                    placeholder="Example: 10.0.0.0/8"
                                                    validations={{
                                                        mustbeip: (values, value) => {
                                                            return validationInput('PrivateIP', values.instance_id, value, 1, "oracle");
                                                        }
                                                    }}
                                                    validationErrors={{
                                                        mustbeip: validationMess('PrivateIP', form.instance_id, 1, "oracle")
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'w-1/4 ml-16')}
                                                    id="oracle_vcn_id"
                                                    name="vcn_id"
                                                    label="VCN ID"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.network.vcn_id}
                                                    onChange={e => setNetworkObj(e.target)}
                                                    fullWidth
                                                />
                                                <CheckboxFormsy
                                                    style={{
                                                        color: (3, 155, 229),
                                                        transform: 'scale(1.5)'
                                                    }}
                                                    id="oracle_isPrivate"
                                                    name="isPrivate"
                                                    label="Private IP"
                                                    value={Boolean(form.data.server.isPrivate)}
                                                    checked={form.data.server.isPrivate}
                                                    onChange={e => setServerObj({ name: e.target.name, value: !form.data.server.isPrivate })}
                                                />
                                            </div>

                                            {/* Volume Configuration */}
                                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: '12px', marginTop: '16px' }}>Volume Configuration</Typography>
                                            <div style={inputGroupStyle}>
                                                <TextFieldFormsy
                                                    className={clsx(classes.input)}
                                                    style={{ flex: 1 }}
                                                    id="oracle_server-volume_size"
                                                    name="volume_size"
                                                    label="Server Volume (GB)"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.server.volume_size}
                                                    onChange={e => setServerObj(e.target)}
                                                    fullWidth
                                                    placeholder={`Min: ${providerVolsize.min}, Max: ${providerVolsize.max}`}
                                                    validations={{
                                                        mustbenumber: (formValues, fieldValue) => {
                                                            return validationInput(
                                                                'clusterservervolume',
                                                                formValues.instance_id,
                                                                fieldValue,
                                                                1,
                                                                "oracle",
                                                                currentMarketStack
                                                            );
                                                        }
                                                    }}
                                                    validationErrors={{
                                                        mustbenumber: validationMess('clusterservervolume', form.instance_id, 1, "oracle")
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'mr-8')}
                                                    id="oracle_node-volume_size"
                                                    name="volume_size"
                                                    label="Node Volume (GB)"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.node.volume_size}
                                                    onChange={e => setNodeObj(e.target)}
                                                    fullWidth
                                                    placeholder={`Disk size of the Cluster Nodes (Min: ${providerVolsize.min}, Max: ${providerVolsize.max})`}
                                                    validations={{
                                                        mustbenumber: (formValues, fieldValue) => {
                                                            const minValue = currentMarketStack ? currentMarketStack.config.node_volume : 1;
                                                            return validationInput('clusternodevolume', formValues.instance_id, fieldValue, minValue, "oracle", currentMarketStack);
                                                        }
                                                    }}
                                                    validationErrors={{
                                                        mustbenumber: validationMess('clusternodevolume', form.instance_id, currentMarketStack ? currentMarketStack.config.node_volume : 1, "oracle", currentMarketStack)
                                                    }}
                                                />

                                            <TextFieldFormsy
                                                className={clsx(classes.input)}
                                                id="oracle_idle_purge_s"
                                                name="idle_purge_s"
                                                label="Idle Purge Time (S)"
                                                type="number"
                                                variant="outlined"
                                                value={form.data.node.idle_purge_s}
                                                onChange={e => setNodeObj(e.target)}
                                                fullWidth
                                                inputProps={{
                                                    min: 0
                                                }}
                                            />
                                        </div>
                                        
                                        {/* VNC Settings */}
                                        <Typography style={sectionTitleStyle}>VNC Settings</Typography>
                                        <Divider variant="fullWidth" className="my-16" />
                                        <div className="flex flex-row items-center justify-start">
                                            <div className="flex flex-row items-center justify-start w-1/2 mr-8">
                                                VNC Token Authentication:
                                                <Checkbox
                                                    checked={isVncTokenAuthentication}
                                                    onChange={event => {
                                                        const newValue = event.target.checked; 
                                                        setIsVncTokenAuthentication(newValue); 
                                                        setForm(prevForm => ({
                                                            ...prevForm,
                                                            info: {
                                                                ...prevForm.info,
                                                                vncTokenAuthentication: newValue 
                                                            }
                                                        }));
                                                    }}
                                                    name="vncTokenAuthentication"
                                                    color="primary"
                                                />
                                            </div>
                                            <div className="flex flex-row items-center justify-start w-1/2 ml-8">
                                                VNC Remote Client:
                                                <Checkbox
                                                    checked={isVncRemoteClient}
                                                    onChange={event => {
                                                        const newValue = event.target.checked;
                                                        setIsVncRemoteClient(newValue);
                                                        setForm(prevForm => ({
                                                            ...prevForm,
                                                            info: {
                                                                ...prevForm.info,
                                                                vncRemoteClient: newValue
                                                            }
                                                        }));
                                                    }}
                                                    name="vncRemoteClient"
                                                    color="primary"
                                                />
                                            </div>
                                        </div>
                                        <Divider variant="fullWidth" className="my-16" />
                                        <div className="flex flex-row items-center justify-start">
                                            <div className="flex flex-row items-center justify-between w-2/3 mr-8">
                                                <div className="flex flex-row items-center w-1/2">
                                                    <Typography className="font-bold mr-16 px-5">User Script:</Typography>
                                                    <React.Fragment>
                                                        <input
                                                            className={classes.uploadInput}
                                                            onChange={e => handleUpload(e)}
                                                            id="oracle_upload-btn"
                                                            type="file"
                                                        />
                                                        <label htmlFor="oracle_upload-btn">
                                                            <Button
                                                                id="oracle_upload-label"
                                                                className="whitespace-no-wrap mr-2"
                                                                component="span"
                                                                variant="contained"
                                                                color="secondary"
                                                            >
                                                                Upload Script
                                                            </Button>
                                                        </label>
                                                    </React.Fragment>
                                                </div>
                                                {!form.data.provision.script ? (
                                                    <div className="flex items-center justify-center h-full w-1/2">
                                                        <Typography id="oracle_no-data-files-msg" color="textSecondary" variant="h6">
                                                            No Script
                                                        </Typography>
                                                    </div>
                                                ) : (
                                                    <Paper
                                                        elevation={0}
                                                        variant="outlined"
                                                        className={clsx(classes.border, 'flex items-center w-4/5 h-48 p-4')}
                                                    >
                                                        <Typography id="oracle_script-name" className="text-center w-2/5">
                                                            User Script
                                                        </Typography>
                                                        <Typography id="oracle_script-blank" className="w-2/5"></Typography>
                                                        <Typography id="oracle_script-actions" className="flex items-center justify-center w-1/5 mr-2">
                                                            <IconButton id="oracle_script-actions-delete" onClick={handleDeleteScript}>
                                                                <Icon>delete</Icon>
                                                            </IconButton>
                                                            <IconButton id="script-actions-view" onClick={() => setScriptOpen(true)}>
                                                                <Icon>visibility</Icon>
                                                            </IconButton>
                                                        </Typography>
                                                    </Paper>
                                                )}
                                            </div>
                                            <div className="flex flex-row items-center justify-start w-1/3 ml-8">
                                                <SelectFormsy
                                                    className={clsx(classes.input, 'w-full')}
                                                    id="oracle_share"
                                                    name="share"
                                                    label="Share"
                                                    type="select"
                                                    variant="outlined"
                                                    value={form.data.share}
                                                    onChange={e => setDataObj(e.target)}
                                                    fullWidth
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: { maxHeight: 300 }
                                                        }
                                                    }}
                                                >
                                                    <MenuItem id="oracle_nfs" value="nfs">
                                                        NFS
                                                    </MenuItem>
                                                    <MenuItem id="oracle_beegfs" value="beegfs">
                                                        BeeGFS
                                                    </MenuItem>
                                                </SelectFormsy>
                                            </div>
                                        </div>
                                        {/* Global Provision Scripts Preview */}
                                        <Divider variant="fullWidth" className="my-16" />
                                        <GlobalProvisionScriptsPreview
                                            provider="oracle"
                                            osType={form?.info?.['os-type']}
                                            clusterName={form?.name}
                                            clusterId={form?.id}
                                            excludedScripts={excludedGlobalScripts}
                                            onExcludedScriptsChange={setExcludedGlobalScripts}
                                        />
                                        {/* Cluster Applications - Feature: cluster-apps */}
                                        <Divider variant="fullWidth" className="my-16" />
                                        <ClusterApplicationsSection
                                            applications={clusterApplications}
                                            onChange={setClusterApplications}
                                            disabled={disableInputs}
                                        />
                                        
                                        {/* Packages Section */}
                                        <Divider variant="fullWidth" className="my-16" />
                                        <div className="flex flex-row items-center justify-start">
                                            <div className="flex flex-row items-center justify-start w-1/2 mr-8">
                                                <Typography className="font-bold mr-16 px-5">Packages:</Typography>
                                                <Paper
                                                    elevation={0}
                                                    variant="outlined"
                                                    className={clsx(classes.borderHover, 'flex items-center h-48 p-4')}
                                                >
                                                    <InputBase
                                                        inputRef={pkgRef}
                                                        className={clsx(classes.input, 'mx-8')}
                                                        placeholder="Linux Package Name"
                                                        id="oracle_packages"
                                                        name="packages"
                                                        type="text"
                                                        value={pkgRef.current && pkgRef.current.value ? pkgRef.current.value : ''}
                                                        onChange={handleChange}
                                                        fullWidth
                                                    />
                                                    <Divider className="h-28 m-4" orientation="vertical" />
                                                    <Button
                                                        className="whitespace-no-wrap"
                                                        id="oracle_add-pkg-btn"
                                                        disabled={Boolean((pkgRef.current && !pkgRef.current.value) || !pkgRef.current)}
                                                        onClick={setPackagesArr}
                                                    >
                                                        Add
                                                    </Button>
                                                </Paper>
                                            </div>
                                            <div className="flex flex-col items-center justify-center w-1/2 ml-8">
                                                {form.data.packages.length === 0 ? (
                                                    <div className="flex items-center justify-center h-full w-3/5">
                                                        <Typography id="oracle_no-data-files-msg" color="textSecondary" variant="h6">
                                                            No Packages
                                                        </Typography>
                                                    </div>
                                                ) : (
                                                    <Paper className="w-full">
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell id="oracle_package-name">Name</TableCell>
                                                                    <TableCell id="oracle_package-blank"></TableCell>
                                                                    <TableCell id="oracle_package-actions">Actions</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {form.data.packages.map((n, i) => {
                                                                    return (
                                                                        <TableRow key={i}>
                                                                            <TableCell id={`${n}-name`} className="w-2/5">
                                                                                {n}
                                                                            </TableCell>
                                                                            <TableCell id={`${n}-blank`} className="w-2/5"></TableCell>
                                                                            <TableCell id={`${n}-actions`} className="w-1/5">
                                                                                <div className="flex items-center">
                                                                                    <IconButton
                                                                                        id={`${n}-actions-delete`}
                                                                                        onClick={() => handleDeletePackages(n)}
                                                                                    >
                                                                                        <Icon>delete</Icon>
                                                                                    </IconButton>
                                                                                </div>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </Paper>
                                                )}
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                                )}

                                {/* Compute Nodes Card */}
                                <Card style={cardStyle}>
                                    <CardHeader
                                        title={
                                            <Box display="flex" alignItems="center">
                                                <Icon style={{marginRight: '8px', color: '#2196F3'}}>dns</Icon>
                                                <Typography style={sectionTitleStyle}>Compute Nodes</Typography>
                                                <Tooltip title="The available Regions, Availability Zones, Server Instance Sizes, Compute Node Instance Sizes may vary based on your provider account status.">
                                                    <Icon style={tooltipIconStyle}>help_outline</Icon>
                                                </Tooltip>
                                            </Box>
                                        }
                                        action={
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={addComputeNode}
                                                startIcon={<Icon>add</Icon>}
                                            >
                                                ADD NODE GROUP
                                            </Button>
                                        }
                                        style={cardHeaderStyle}
                                    />
                                    <CardContent>
                                <div className="flex flex-row items-center justify-between">
                                    <div className="flex items-center justify-start">
                                        <Typography className="font-bold mr-8 px-5">Node Groups:</Typography>
                                        <Typography
                                            aria-owns={anchorEl ? 'mouse-over-popover' : undefined}
                                            aria-haspopup="true"
                                            // onMouseEnter={handlePopoverOpen}
                                            onMouseEnter={(e) => handlePopoverOpen(e, "popover1")}
                                            onMouseLeave={handlePopoverClose}
                                        >
                                            <Icon fontSize="small" color="secondary">
                                                info
                                            </Icon>
                                        </Typography>
                                        <Popover
                                            // id="oracle_mouse-over-popover"
                                            id="oracle_popover1"
                                            className={classes.popover}
                                            classes={{
                                                paper: classes.paper
                                            }}
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left'
                                            }}
                                            transformOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            }}
                                            onClose={handlePopoverClose}
                                            disableAutoFocus={true}
                                            disableEnforceFocus={true}
                                            disableRestoreFocus={true}
                                            transitionDuration={{ enter: 300 }}
                                        >
                                            {/* {anchorEl?.textContent?.includes('info') && ( */}
                                            <Typography>
                                                *The available Regions, Availability Zones, Server Instance Sizes, Compute Node Instance Sizes
                                                and quantity of Instances may vary based on your provider account status.
                                            </Typography>
                                            {/* )} */}
                                        </Popover>
                                    </div>

                                    <div>
                                        <Fab
                                            className="mx-4"
                                            id="oracle_add-node-size-btn"
                                            color="secondary"
                                            size="small"
                                            aria-label="add"
                                            onClick={addComputeNode}
                                        >
                                            <Icon>add</Icon>
                                        </Fab>
                                    </div>
                                </div>

                                {nodeInstanceSizes &&
                                    form.data.node.group.map((val, i) => {
                                        return (
                                            <div key={`node-${i}`} className="flex flex-row w-full my-16">
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'w-1/2 mr-8')}
                                                    id="oracle_group_node_prefix_label"
                                                    name="group_node_prefix_label"
                                                    label="Label"
                                                    type="text"
                                                    variant="outlined"
                                                    value={val.group_node_prefix_label ? val.group_node_prefix_label : null}
                                                    onChange={e => setNodePrefixLabel(i, e.target.value)}
                                                    fullWidth
                                                    required
                                                    placeholder="Label"
                                                />
                                                {/* Only show node prefix selection in multi-image mode */}
                                                {/* In unified mode, all nodes use the head node's image automatically */}
                                                {imageMode === IMAGE_MODE.MULTI_IMAGE && (
                                                    <>
                                                        <TextField
                                                            ref={el => groupNodePrefixRefs.current[i] = el}
                                                            className={clsx(classes.input, 'ml-8 w-1/2 mr-8')}
                                                            label="Node Stack"
                                                            value={groupNodeInputValues[i] || ''}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                setGroupNodeInputValues(prevValues => ({
                                                                    ...prevValues,
                                                                    [i]: newValue
                                                                }));
                                                                setNodePrefix(i, newValue);
                                                                validateNodePrefix(newValue, i);
                                                            }} variant="outlined"
                                                            fullWidth
                                                            required
                                                            error={nodePrefixErrors[i] ? true : false}
                                                            helperText={nodePrefixErrors[i]}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton onClick={() => handleGroupNodeMenuOpen(i)}>
                                                                            <ArrowDropDownIcon />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                        <Menu
                                                            anchorEl={groupNodePrefixRefs.current[activeMenuIndex]}
                                                            open={activeMenuIndex === i}
                                                            onClose={() => setActiveMenuIndex(null)}
                                                        >
                                                            {
                                                                stacks
                                                                    .filter(stack => stack.info?.state === "success" && stack?.provider === "oracle")
                                                                    .length > 0
                                                                    ? stacks
                                                                        .filter(stack => stack.info?.state === "success" && stack?.provider === "oracle")
                                                                .map((stack, index) => (
                                                                    <MenuItem
                                                                        key={index}
                                                                        onClick={() => handleGroupNodeMenuItemClick(i, stack.data.prefix)}
                                                                    >
                                                                        {stack.data.prefix}
                                                                    </MenuItem>
                                                                ))
                                                            : <MenuItem disabled>No stack builds available for this provider</MenuItem>
                                                    }
                                                        </Menu>
                                                    </>
                                                )}
                                                <SelectFormsy
                                                    className={clsx(classes.input, 'w-full mr-8')}
                                                    id={`node-size-${i}`}
                                                    name="node_instance_id"
                                                    label="Size *"
                                                    type="select"
                                                    variant="outlined"
                                                    value={val.instance_id}
                                                    onChange={e => setInstanceId(i, e.target.value)}
                                                    fullWidth
                                                    required
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: { maxHeight: 300 }
                                                        }
                                                    }}
                                                >
                                                    {
                                                        nodeInstanceSizes
                                                            .filter(s => !marketplaceComputeIds || marketplaceComputeIds.includes(s.instance_id))
                                                            .map((s, i) => (
                                                                <MenuItem
                                                                    id={`server-${s.name}`}
                                                                    key={i}
                                                                    value={s.instance_id}
                                                                >
                                                                    {s.name}
                                                                </MenuItem>
                                                            ))
                                                    }
                                                </SelectFormsy>

                                                {val.instance_id.includes('Flex') && (
                                                    //Flex Instance Node UI boxes
                                                    <React.Fragment key={`oracle-node-flex${i}`}>
                                                        <TextFieldFormsy
                                                            className={clsx(classes.input, 'w-1/3 mx-8 ')}
                                                            id={`node-ocpus-${i}`}
                                                            name={`node-ocpus-${i}`}
                                                            label="Node Cores(OCPUs)"
                                                            type="text"
                                                            variant="outlined"
                                                            value={form.data.node.group[i].ocpus}
                                                            onChange={e => setNodeOCPUS(i, e.target.value)}
                                                            required
                                                            autoFocus
                                                            fullWidth
                                                            inputProps={{
                                                                min: 1
                                                            }}
                                                            validations={{
                                                                NodehasCharactersOrZero: (formValues, fieldValue) => {
                                                                    return validationInput('ocpus', val.instance_id, fieldValue, val.ocpus, "oracle");
                                                                }
                                                            }}
                                                            validationErrors={{
                                                                NodehasCharactersOrZero: validationMess(
                                                                    'ocpuserror',
                                                                    val.instance_id,
                                                                    val.ocpus,
                                                                    "oracle"
                                                                )
                                                            }}
                                                        />
                                                        <TextFieldFormsy
                                                            className={clsx(classes.input, 'w-1/3 mx-8 ')}
                                                            id={`node-mem-${i}`}
                                                            name={`node-mem-${i}`}
                                                            label="Node Mem(GB)"
                                                            type="text"
                                                            variant="outlined"
                                                            value={form.data.node.group[i].mem}
                                                            onChange={e => setNodeMEM(i, e.target.value)}
                                                            fullWidth
                                                            required
                                                            autoFocus
                                                            inputProps={{
                                                                min: 1
                                                            }}
                                                            validations={{
                                                                NodemustBeEqualOrGreaterThanOCPUS: (formValues, fieldValue) => {
                                                                    return validationInput('mem', val.instance_id, fieldValue, val.ocpus, "oracle");
                                                                }
                                                            }}
                                                            validationErrors={{
                                                                NodemustBeEqualOrGreaterThanOCPUS: validationMess(
                                                                    'memerror',
                                                                    val.instance_id,
                                                                    val.ocpus,
                                                                    val.mem,
                                                                    "oracle"
                                                                )
                                                            }}
                                                        />
                                                    </React.Fragment>
                                                )}
                                                {val.instance_id === TEMPORARY_SUPPORTED_MIG_CAPABLE_DEVICE && (
                                                    <>
                                                        {!Array.isArray(form.data.node.mig_config) &&
                                                            setMigMode(val.instance_id, TEMPORARY_MIG_MODES[0])}
                                                        <SelectFormsy
                                                            className={clsx(classes.input, 'w-1/3 mx-8')}
                                                            id="oracle_mig-mode"
                                                            name="mig-mode"
                                                            label="MIG Mode *"
                                                            type="select"
                                                            variant="outlined"
                                                            value={
                                                                props.type === 'edit'
                                                                    ? form.data.node.mig_config.reduce((mode, config) => {
                                                                        if (mode !== '') return mode;
                                                                        if (config.instance_id === val.instance_id) return config.mig_mode;
                                                                        return '';
                                                                    }, '')
                                                                    : TEMPORARY_MIG_MODES[0]
                                                            }
                                                            onChange={e => setMigMode(val.instance_id, e.target.value.toLowerCase())}
                                                            fullWidth
                                                            required
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    style: { maxHeight: 300 }
                                                                }
                                                            }}
                                                        >
                                                            {TEMPORARY_MIG_MODES.map((mode, i) => (
                                                                <MenuItem id={`mig-${mode.toLowerCase()}`} key={i} value={mode}>
                                                                    {mode}
                                                                </MenuItem>
                                                            ))}
                                                        </SelectFormsy>
                                                    </>
                                                )}
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'w-2/12 mx-8')}
                                                    id={`count-${i}`}
                                                    name="count"
                                                    label="Count"
                                                    type="number"
                                                    variant="outlined"
                                                    value={val.count || "0"}
                                                    onChange={e => setInstanceCount(i, e.target, val.instance_id)}
                                                    required
                                                    fullWidth
                                                    inputProps={{
                                                        min: 0,
                                                        max: 250
                                                    }}
                                                />
                                                <div className="flex flex-col item-center justify-center w-1/12 ml-8">
                                                    <Fab
                                                        id={`delete-btn-${i}`}
                                                        disabled={form.data.node.group.length <= 1}
                                                        color="secondary"
                                                        size="small"
                                                        aria-label="delete"
                                                        onClick={() => removeComputeNode(i)}
                                                    >
                                                        <Icon className="item-center justify-center">delete</Icon>
                                                    </Fab>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    </CardContent>
                                </Card>

                                <TextField
                                    className={clsx(classes.input, 'my-16 w-full')}
                                    id="oracle_description"
                                    name="description"
                                    label="Description"
                                    type="textarea"
                                    variant="outlined"
                                    value={form.description}
                                    onChange={handleChange}
                                    fullWidth
                                    multiline
                                    minRows={3}
                                />
                            </Formsy>
                        </DisabledFormWrapper>
                    </DialogContent>
                </React.Fragment>
            )}
            <ScriptDialog
                open={isScriptOpen}
                onClose={() => setScriptOpen(false)}
                scriptContent={form?.data?.provision?.script || ''}
            />
        </React.Fragment>
    );
};

export default OracleCluster;
